export const FACE_DETECTED = {
    DEFAULT: 'default',
    DETECTED: 'Face detected',
    NOT_DETECTED: 'Face not detected',
};

export const VIDEO_ID = 'preview_tile';
